export default __webpack_public_path__ + "maps-guides-styles-layers-line-layer-960-9d4055fb50872084e0f122f32d92e91d.png";